import styled from 'styled-components';

const Wrapper = styled.div`
  margin: 0 auto;
  max-width: var(--max-width);
  padding: 1rem 1rem;
  height: 100%;
`;

export default Wrapper;
